"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 101;\n"], ["\n  background: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 101;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  opacity: 0.9;\n  font-family: ", ";\n  font-weight: ", ";\n  padding: 32px;\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  z-index: 102;\n  width: 275px;\n  -webkit-font-smoothing: antialiased;\n  transform: ", ";\n  transition: ", ";\n  box-sizing: border-box;\n"], ["\n  background: ", ";\n  opacity: 0.9;\n  font-family: ", ";\n  font-weight: ", ";\n  padding: 32px;\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  z-index: 102;\n  width: 275px;\n  -webkit-font-smoothing: antialiased;\n  transform: ", ";\n  transition: ", ";\n  box-sizing: border-box;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  padding-top: 60px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n"], ["\n  padding-top: 60px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n  letter-spacing: 0.02rem;\n  margin: 0 0 25px 0;\n  cursor: pointer;\n  text-decoration: none;\n  ", ";\n  ", ";\n  // Hiding log in across all experiences temporarily for MA release but NOT subdomain clients\n  ", ";\n  &:hover,\n  &:focus,\n  &:active {\n    color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  color: ", ";\n  ", ";\n  letter-spacing: 0.02rem;\n  margin: 0 0 25px 0;\n  cursor: pointer;\n  text-decoration: none;\n  ", ";\n  ", ";\n  // Hiding log in across all experiences temporarily for MA release but NOT subdomain clients\n  ", ";\n  &:hover,\n  &:focus,\n  &:active {\n    color: ", ";\n    text-decoration: none;\n  }\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n  "], ["\n    ", ";\n  "]),
    _templateObject6 = _taggedTemplateLiteral([" display: none;"], [" display: none;"]),
    _templateObject7 = _taggedTemplateLiteral(["\n      display: none;\n    "], ["\n      display: none;\n    "]),
    _templateObject8 = _taggedTemplateLiteral(["\n  color: ", ";\n  width: 208px;\n  position: absolute;\n  bottom: 7rem;\n"], ["\n  color: ", ";\n  width: 208px;\n  position: absolute;\n  bottom: 7rem;\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  position: absolute;\n  bottom: 3.17rem;\n"], ["\n  ", ";\n  position: absolute;\n  bottom: 3.17rem;\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  margin-top: 7px;\n"], ["\n  display: block;\n  width: 100%;\n  margin-top: 7px;\n"]),
    _templateObject11 = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: ", ";\n  }\n"], ["\n  text-decoration: underline;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: ", ";\n  }\n"]),
    _templateObject12 = _taggedTemplateLiteral(["\n  color: ", ";\n  letter-spacing: 0.01rem;\n  line-height: 1.3;\n  ", ";\n  ", ";\n"], ["\n  color: ", ";\n  letter-spacing: 0.01rem;\n  line-height: 1.3;\n  ", ";\n  ", ";\n"]),
    _templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  width: 100%;\n  text-align: right;\n"], ["\n  ", ";\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  width: 100%;\n  text-align: right;\n"]),
    _templateObject14 = _taggedTemplateLiteral(["\n  line-height: 1.3;\n  color: ", ";\n  margin: 0 0.33rem;\n"], ["\n  line-height: 1.3;\n  color: ", ";\n  margin: 0 0.33rem;\n"]),
    _templateObject15 = _taggedTemplateLiteral(["\n  margin-bottom: 12px;\n  max-width: 132px;\n"], ["\n  margin-bottom: 12px;\n  max-width: 132px;\n"]),
    _templateObject16 = _taggedTemplateLiteral(["\n  display: ", ";\n"], ["\n  display: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _buoyButton = require("buoy-button");

var _buoyCloseIcon = require("buoy-close-icon");

var _buoyCloseIcon2 = _interopRequireDefault(_buoyCloseIcon);

var _buoyTheme = require("buoy-theme");

var _PoweredBy = require("./components/PoweredBy");

var _PoweredBy2 = _interopRequireDefault(_PoweredBy);

var _dist = require("react-intl/dist");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Overlay = _styledComponents2.default.div.withConfig({
  displayName: "src__Overlay",
  componentId: "sc-1oa1lst-0"
})(_templateObject);

var NavContainer = _styledComponents2.default.nav.withConfig({
  displayName: "src__NavContainer",
  componentId: "sc-1oa1lst-1"
})(_templateObject2, function (props) {
  return props.color ? props.color : _buoyTheme.colors.primary(props);
}, _buoyTheme.fontFamily, _buoyTheme.fontWeight.regular, function (props) {
  return props.show ? "translateX(0)" : "translateX(100%)";
}, function (props) {
  return props.show ? "all 0.3s ease 0.2s" : "all ease 0.3s";
});

var Menu = _styledComponents2.default.div.withConfig({
  displayName: "src__Menu",
  componentId: "sc-1oa1lst-2"
})(_templateObject3);

var MenuLink = _styledComponents2.default.a.withConfig({
  displayName: "src__MenuLink",
  componentId: "sc-1oa1lst-3"
})(_templateObject4, _buoyTheme.colors.white, (0, _buoyTheme.fontSize)("bodyLarger"), function (props) {
  return props.mobileOnly ? (0, _styledComponents.css)(_templateObject5, (0, _buoyTheme.responsive)("display", "none", "none", "block", "block", "block")) : "\n    display: block;\n  ";
}, function (props) {
  return props.link.text === "Businesses" && props.isConfiguredExperience && (0, _styledComponents.css)(_templateObject6);
}, function (props) {
  return props.link.text === "Log in / Sign up" && (props.brand === "public" || props.isConfiguredExperience) && (0, _styledComponents.css)(_templateObject7);
}, _buoyTheme.colors.white);

var CTA = (0, _styledComponents2.default)(_buoyButton.LinkButton).withConfig({
  displayName: "src__CTA",
  componentId: "sc-1oa1lst-4"
})(_templateObject8, _buoyTheme.colors.primary);

var LegalSectionContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__LegalSectionContainer",
  componentId: "sc-1oa1lst-5"
})(_templateObject9, (0, _buoyTheme.fontSize)("bodySmall"));

var LegalRow = _styledComponents2.default.div.withConfig({
  displayName: "src__LegalRow",
  componentId: "sc-1oa1lst-6"
})(_templateObject10);

var LegalLink = _styledComponents2.default.a.withConfig({
  displayName: "src__LegalLink",
  componentId: "sc-1oa1lst-7"
})(_templateObject11, _buoyTheme.colors.white, _buoyTheme.colors.white);

var LegalText = _styledComponents2.default.span.withConfig({
  displayName: "src__LegalText",
  componentId: "sc-1oa1lst-8"
})(_templateObject12, _buoyTheme.colors.white, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return props.block && "display: block;";
});

var LegalFixedText = (0, _styledComponents2.default)(LegalText).withConfig({
  displayName: "src__LegalFixedText",
  componentId: "sc-1oa1lst-9"
})(_templateObject13, (0, _buoyTheme.fontSize)("bodySmall"));

var Dot = _styledComponents2.default.span.withConfig({
  displayName: "src__Dot",
  componentId: "sc-1oa1lst-10"
})(_templateObject14, _buoyTheme.colors.white);

var LegalImg = _styledComponents2.default.img.withConfig({
  displayName: "src__LegalImg",
  componentId: "sc-1oa1lst-11"
})(_templateObject15);

var LegalSection = function LegalSection(_ref) {
  var items = _ref.items,
      navRef = _ref.navRef,
      show = _ref.show;
  return _react2.default.createElement(
    LegalSectionContainer,
    null,
    items.map(function (row, rowIndex) {
      return _react2.default.createElement(
        LegalRow,
        { key: rowIndex },
        row.map(function (item, itemIndex) {
          return _react2.default.createElement(
            _react2.default.Fragment,
            { key: itemIndex },
            item.type === "link" && itemIndex !== 0 && _react2.default.createElement(
              Dot,
              null,
              "\xB7"
            ),
            item.type === "link" && _react2.default.createElement(
              LegalLink,
              { tabIndex: show ? 0 : -1, href: item.href },
              item.text === "Terms" && _react2.default.createElement(_dist.FormattedMessage, { id: "nav.links.terms", defaultMessage: item.text }),
              item.text === "Privacy" && _react2.default.createElement(_dist.FormattedMessage, { id: "nav.links.privacy", defaultMessage: item.text }),
              item.text === "Support" && _react2.default.createElement(_dist.FormattedMessage, { id: "nav.links.support", defaultMessage: item.text })
            ),
            item.type === "text" && _react2.default.createElement(
              LegalText,
              null,
              item.text
            ),
            item.type === "image" && _react2.default.createElement(LegalImg, { src: item.src, alt: item.alt }),
            item.type === "fixedtext" && navRef && _reactDom2.default.createPortal(_react2.default.createElement(
              LegalFixedText,
              null,
              item.text
            ), navRef)
          );
        })
      );
    })
  );
};

var SideNavContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__SideNavContainer",
  componentId: "sc-1oa1lst-12"
})(_templateObject16, function (props) {
  return props.show ? "block" : "none";
});

var SidebarNav = function (_React$Component) {
  _inherits(SidebarNav, _React$Component);

  function SidebarNav() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, SidebarNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SidebarNav.__proto__ || Object.getPrototypeOf(SidebarNav)).call.apply(_ref2, [this].concat(args))), _this), _this.onLinkClick = function (href, onClick, newTab) {
      return function (e) {
        e.preventDefault();

        if (onClick) {
          onClick();
        } else if (newTab) {
          window.open(href, "_blank");
        } else {
          if (typeof window !== "undefined") {
            window.location = href;
            if (window.location.hash) {
              _this.props.onToggle();
            }
          }
        }
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SidebarNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          color = _props.color,
          show = _props.show,
          menuLinks = _props.menuLinks,
          legalItems = _props.legalItems,
          onToggle = _props.onToggle,
          showPoweredBy = _props.showPoweredBy,
          poweredByUrl = _props.poweredByUrl,
          cta = _props.cta,
          isConfiguredExperience = _props.isConfiguredExperience,
          brand = _props.brand;


      var path = typeof window !== "undefined" ? window.location.pathname.slice(1, window.location.pathname.length - 1) : "";

      return _react2.default.createElement(
        SideNavContainer,
        { show: show },
        show && _react2.default.createElement(Overlay, { onClick: onToggle }),
        _react2.default.createElement(
          NavContainer,
          {
            innerRef: function innerRef(nav) {
              return _this2.nav = nav;
            },
            show: show,
            color: color
          },
          _react2.default.createElement(_buoyCloseIcon2.default, {
            color: _buoyTheme.colors.white(this.props),
            disabled: !show,
            onClick: onToggle
          }),
          _react2.default.createElement(
            Menu,
            null,
            menuLinks.map(function (link) {
              return _react2.default.createElement(
                MenuLink,
                {
                  tabIndex: show ? 0 : -1,
                  key: link.text,
                  href: link.disabled ? null : link.href,
                  mobileOnly: link.mobileOnly,
                  onClick: link.disabled ? null : _this2.onLinkClick(link.href, link.onClick, link.newTab),
                  isConfiguredExperience: isConfiguredExperience,
                  link: link,
                  brand: brand
                },
                link.text === "Log in / Sign up" && _react2.default.createElement(_dist.FormattedMessage, { id: "nav.links.auth", defaultMessage: link.text }) || link.text
              );
            })
          ),
          cta && path !== "symptom-checker" && _react2.default.createElement(
            CTA,
            {
              color: "white",
              ghost: false,
              href: cta.href
            },
            cta.text
          ),
          _react2.default.createElement(LegalSection, { show: show, items: legalItems, navRef: this.nav }),
          showPoweredBy && _react2.default.createElement(_PoweredBy2.default, { url: poweredByUrl })
        )
      );
    }
  }]);

  return SidebarNav;
}(_react2.default.Component);

SidebarNav.propTypes = {
  color: _propTypes2.default.string,
  show: _propTypes2.default.bool,
  menuLinks: _propTypes2.default.array.isRequired,
  legalItems: _propTypes2.default.array,
  onToggle: _propTypes2.default.func.isRequired,
  showPoweredBy: _propTypes2.default.bool,
  poweredByUrl: _propTypes2.default.string
};

SidebarNav.defaultProps = {
  show: false,
  showPoweredBy: false,
  legalItems: []
};

exports.default = (0, _styledComponents.withTheme)(SidebarNav);


//////////////////
// WEBPACK FOOTER
// ./~/buoy-sidebar-nav/dist/index.js
// module id = 229
// module chunks = 168707334958949